function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.7,
    height: 25.5,
    viewBox: "0 0 20.7 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "file (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1651",
    d: "M14.8 2H6.4A2.4 2.4 0 0 0 4 4.4v19.2A2.4 2.4 0 0 0 6.4 26h14.4a2.4 2.4 0 0 0 2.4-2.4V10.4z",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    transform: "translate(-3.25 -1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1652",
    d: "M13 2v8.4h8.4",
    transform: "translate(-1.45 -1.25)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.afaa204d6820036e88606441733a390b.svg";
export { ForwardRef as ReactComponent };